import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IStatSummary {
    day: string
    short_count: number
    long_count: number
    long_short_ratio: number
    entry_short_volume: number
    entry_long_volume: number
    short_volume: number
    long_volume: number
    holding_long_volume: number
    holding_short_volume: number
    long_short_count_ratio: number
    long_short_volume_ratio: number
    holding_btc_volume: number
    holding_alt_volume: number
    holding: number
    trending: string[]
    created_at: string
    group: string
}

export const Groups = {
    TopTraders: 'Key Profit alltime Initialbalance + deposits > 10000 And Profit > 15',
    WhaleTraders: 'Initialbalance +Deposits > 100000',
    WhaleCurrentTraders: 'Current balacne > 50000',
}

export const getData = async (days: number, group: string): Promise<ApiRes<IStatSummary[]>> => {
    return await apiGet(API_URL, `admin/stat?days=${days}&group=${group}`)
}
